export default __webpack_public_path__ + "static/life-illus-4d63d0015af1fe375a22acd5a5746c47.svg";